<template>
    <v-container>
        <v-card>
            <v-card-title class="primary"><span class="white--text">Password Setup</span></v-card-title>
            <v-card-text>
                <div>
                    Please provide your email, temporary password provided in your confirmation
                    message along with your new password.
                </div>
                <v-alert class="mt-3" dense outlined type="error" v-if="loginError" >
                    {{loginError}}
                </v-alert>
                <v-form
                        lazy-validation
                        ref="form"
                        v-model="valid"
                >
                    <v-text-field
                            :rules="formRules.username"
                            label="Username"
                            required
                            v-model="formData.username"
                            id="username"
                            @keydown="loginKey"
                    ></v-text-field>

                    <v-text-field
                            :rules="formRules.password"
                            label="Temporary Password"
                            required
                            type="password"
                            v-model="formData.password"
                            @keydown="loginKey"
                    ></v-text-field>

                    <v-text-field
                            :rules="formRules.newPassword"
                            label="New Password"
                            required
                            type="password"
                            v-model="formData.newPassword"
                            @keydown="loginKey"
                    ></v-text-field>

                    <v-text-field
                            :rules="formRules.newPasswordConfirmation"
                            label="New Password Confirmation"
                            required
                            type="password"
                            v-model="formData.newPasswordConfirmation"
                            @keydown="loginKey"
                    ></v-text-field>
                    <div v-if="formData.newPassword && formData.newPassword != formData.newPasswordConfirmation" class="error--text">
                        Password Confirmation Must Match
                    </div>


                    <v-btn
                            :disabled="!valid || formData.newPassword != formData.newPasswordConfirmation"
                            @click="login"
                            class="mr-4"
                            color="success"
                    >
                        Login
                    </v-btn>
                </v-form>
            </v-card-text>
        </v-card>
        <v-dialog max-width="290" persistent v-model="errorDialog">
            <v-card>
                <v-card-title class="error white--text">Error</v-card-title>
                <v-card-text>{{errorText}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="errorDialog = false" color="green darken-1" text>OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import api from "../services/aggrega8-api";

    export default {
        name: 'login',

        computed: {
            apiKey: function () {
                return this.$store.state.apiKey
            },
            userDetails: function () {
                return this.$store.state.userDetails
            },
            loggedIn: function () {
                return this.$store.state.loggedIn
            },
            selectedProgram: function () {
                return this.$store.state.selectedProgram
            },
        },

        data: () => ({
            errorDialog: false,
            errorText: "",
            valid: false,
            formData: {
                username: '',
                password: '',
                newPassword: '',
                newPasswordConfirmation: ''
            },
            formRules: {
                username: [
                    v => !!v || 'Username is required'
                ],
                password: [
                    v => !!v || 'Temporary Password is required',
                ],
                newPassword: [
                        v => !!v || 'New password is required',
                        v => {
                            let error = ''
                            error += (v && v.length < 8 && 'be at least 8 characters') || ''
                            error += (!v.match("(.*)[0-9](.*)") && ((error != '' && ', ') || '') + 'contain at least one number') || ''
                            error += (!v.match("^(.*)[a-z](.*)") && ((error != '' && ', ') || '') + 'contain at least one lowercase character') || ''
                            error += (!v.match("^(.*)[A-Z](.*)") && ((error != '' && ', ') || '') + 'contain at least one uppercase character') || ''
                            error += (!v.match("(.*)[^a-zA-Z0-9](.*)") && ((error != '' && ', ') || '') + 'contain at least one symbol') || ''
                            return (error != '') ? 'Password must ' + error : true
                        }
                    ],
                newPasswordConfirmation: [
                    v => !!v || 'Password Confirmation is required',
                    v => v == this.accountData.newPassword || 'Password Confirmation must match'
                ]
            },
            loginError: ""
        }),

        mounted() {
            let el = document.getElementById("username")
            if (el) el.focus()
        },
        methods: {
            loginKey(k) {
                if (k.keyCode == 13) this.login()
            },
            validate() {
                if (this.$refs.form.validate()) {
                    this.snackbar = true
                }
            },
            login() {
                this.$store.dispatch("setExecuting", true)
                api.post("/consumer/firstLogin", {username: this.formData.username,
                    password: this.formData.password, newPassword: this.formData.newPassword}).then(
                (results) => {
                    this.$store.dispatch("setApiKey", results.data.access_token)
                    this.$router.push("/")
                },
                (error) => {
                    this.errorText = error.response.data
                    this.errorDialog = true
                }).then(() => {

                    this.$store.dispatch("setExecuting", false)
                })

            }
        },
    }
</script>
